// External libraries
import { css } from '@emotion/core';

const errorStyleOverrides = css`
  padding-left: 37px;
`;

const textStyles = css`
  line-height: 1.6;
  text-align: left;
`;

export { errorStyleOverrides, textStyles };
